<script setup lang="ts">
//#region import
import { usePopupManager } from '@/components/PopupManager.vue';
import type { DefaultFilterListKeyType, DefaultFilterListType } from '@/views/Dashboard/components/DashboardFilter.vue';
import type { FilterRecordFilter } from '@/types/dashboard';
//#endregion

//#region types
export interface Props {
  searchByList: Record<
    DefaultFilterListKeyType,
    DefaultFilterListType[DefaultFilterListKeyType]
  >,
  isSearchingFilter: Record<string, boolean>,
  reportsSettings: any,
  currentSearch?: any,
  disabled?: boolean,
} 

export interface Emits {
  'selectedSearchFilter': [search: FilterRecordFilter],
  'deleteCurrentSearchGroup': [group: DefaultFilterListKeyType, event: any], 
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
    currentSearch: () => ({}),
    disabled: false,
});

const emit = defineEmits<Emits>();
//#endregion

//#region methods
async function openReportsFilterPopup(group: DefaultFilterListKeyType) {
  usePopupManager().reportsFilter.open({
    data: {
      searchData: props.currentSearch,
      group: group,
    },
    listeners: {
      success: (data) => {
        selectedSearchFilter(data);
      },
    },
  });
}

function clearReportsSearchFilter(group: DefaultFilterListKeyType, event: any) {
  event.stopPropagation();
  emit('deleteCurrentSearchGroup', group, event);
}

function selectedSearchFilter(search: FilterRecordFilter) {
  emit('selectedSearchFilter', search);
}
//#endregion
</script>

<template>
  <div
    class="t:flex t:flex-wrap t:gap-8 t:my-12"
  >
    <UiButton
      v-for="(item, key) in searchByList"
      :key="key"
      :filled="isSearchingFilter[key]"
      :style="{order: item['order']}"
      :icon="item.icon"
      :disabled="disabled"
      :is-clear="isSearchingFilter[key]"
      @click="openReportsFilterPopup(key)"
      @clear-click="disabled ? false : clearReportsSearchFilter(key, $event)"
    >
      {{ $t(`reports.other.search_by.${key}`) }}
    </UiButton>
  </div>
</template>
